var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8AskQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 4.0097656 3 C 2.9077656 3 2.0107656 3.8960469 2.0097656 4.9980469 L 2 22.998047 L 6 19 L 20 19 C 21.103 19 22 18.103 22 17 L 22 5 C 22 3.897 21.103 3 20 3 L 4.0097656 3 z M 4.0097656 5 L 20 5 L 20 17 L 5.171875 17 L 4.0039062 18.169922 L 4.0097656 5 z M 12 6 C 9.954 6 9 7.79 9 9 L 11 9 C 11 8.835 11.174 8 12 8 C 12.989 8 13 8.99 13 9 C 13 10.054 11 12.025 11 13 L 13 13 C 13 12.014 15 10.422 15 9 C 15 7.525 13.878 6 12 6 z M 11 14 L 11 16 L 13 16 L 13 14 L 11 14 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8AskQuestion);
export default __webpack_public_path__ + "static/media/icons8-ask-question.3dce8718.svg";
export { ForwardRef as ReactComponent };